import { useTranslation } from "react-i18next"
import { Text } from "@mantine/core"
import dayjs from "dayjs"
import { useBreakpoints } from "../utils/use-breakpoints"

export function CalendarWeekPeriod({ date }: { date: Date }) {
  const { t } = useTranslation("app_server")
  const { xs } = useBreakpoints()
  const startOfWeek = dayjs(date).startOf("week").toDate()
  const endOfWeek = dayjs(date).endOf("week").toDate()
  const weekNumber = dayjs(date).week()
  const startDay = startOfWeek.getDate().toString().padStart(2, "0")
  const endDay = endOfWeek.getDate().toString().padStart(2, "0")
  const startMonth = (startOfWeek.getMonth() + 1).toString().padStart(2, "0")
  const endMonth = (endOfWeek.getMonth() + 1).toString().padStart(2, "0")
  const startYear = startOfWeek.getFullYear()
  const endYear = endOfWeek.getFullYear()
  return (
    <Text span w={xs ? undefined : 275} truncate fz={{ base: "md", lg: "lg" }}>
      <Text span fw={"bold"}>{`${weekNumber}. ${t("CW_CalendarWeek")}`}</Text>{" "}
      {`${startDay}.${startMonth === endMonth ? "" : `${startMonth}.`}${startYear === endYear ? "" : `${startYear}`}-${endDay}.${endMonth}.${endYear}`}
    </Text>
  )
}
